export enum JobEditorHost {
    None = '',
    Operations = 'operations',
    Finance = 'finance',
    Details = 'details',
    Scheduler = 'scheduler'
}


export enum JobEditorAppointmentMode {
    New = 'New',
    Edit = 'Edit'
}

export enum ActivityMode {
    EditMode = 'Edit',
    ViewMode = 'View'
}

